export const handleScroll = (
  scrollRef: React.RefObject<HTMLElement>,
  notSmooth = false
) =>
  scrollRef?.current?.scrollIntoView({
    behavior: notSmooth ? 'auto' : 'smooth',
    block: 'start',
  });
